import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayViewChecksPage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayViewChecksPage";
import TASPositivePayCheckFormUI from "components/pages/TASPositivePayAddChecksPage/classes/TASPositivePayCheckFormUI";
import TASPositivePayCheckForm from "components/pages/TASPositivePayAddChecksPage/classes/TASPositivePayCheckForm";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayEditCheck
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - View Checks" capture group.
 */
export default function CapturePositivePayEditCheck(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    const search = defaultData.search;
    let checkFormsFiltered = search.filter();
    let accounts = Account.initAllBusinessChecking();
    accounts = accounts.length > 0 ? accounts : [{}];
    const account = accounts[0];

    checkFormsFiltered = checkFormsFiltered.reduce((acc, item, index) => {
        if(index === 0) {
            acc.push(
                TASPositivePayCheckForm.init({ ...item.record, account: account.id, issuedDate: "0", checkNumber: "1017", amount: "3.00" })
            )
        } else {
            acc.push(item);
        }
        return acc;
    }, []);

    const checkFormsUI = checkFormsFiltered.reduce((acc, item, index) => {
        const isEditing = index === 0 ? true : false;

        acc.push(
            TASPositivePayCheckFormUI.init({ ...item.record, isEditing })
        );
        return acc;
    }, []);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "checkForms" ], checkFormsFiltered)
    .update([ "search", "checkForms" ], checkFormsFiltered)
    .update([ "search", "editCheckForms" ], checkFormsFiltered)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "checkForms" ], checkFormsUI)
    .update([ "search", "didSearch", "isActive" ], true)
    .submit();

    return <TASPositivePayViewChecksPage data={ data } ui={ ui } />;
}